<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
  >
    <v-card light>
      <v-card-title v-text="__('legalCookieWarnTitle')" />
      <v-card-text v-text="__('legalCookieWarnText')" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="close()"
          v-text="__('legalCookieWarnButton')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      I18n,
    ],

    data: () => ({
      show: false,
    }),

    created () {
      if (! localStorage.getItem('cookieWarn')) {
        setTimeout(() => this.show = true, 500)
      }
    },

    methods: {
      close () {
        this.show = false
        localStorage.setItem('cookieWarn', 'viewed')
      },
    },
  }
</script>
